import React, {useEffect, useMemo, useState} from 'react';
import {useParams} from 'react-router';
import styled from 'styled-components';
import {serviceURL} from '../../../../../util/uiconstants';
import {useEngagementId} from '../../../../../util/customHooks';
import Env from '../../../../../util/env';
import {getFormBodyDataBySectionId} from '../../../../../selectors/Forms/formBodySelectors';
import {useDispatch, useSelector} from 'react-redux';
import {getFormBodiesBySectionId, getFormData} from '../../../../../actions/FormData/formdataactions';
import Utility from '../../../../../util/utilityfunctions';
import getComponent from './BodiesConfiguration';
import LoadingIndicator from '../../../../../components/Common/LoadingIndicator/LoadingIndicator';
import {getTaskDocumentByDocumentId} from '../../../../../selectors/Ares/selectors';

export default function BodiesContainer() {
	const {documentId, headerId, sectionId, bodyId} = useParams();

	const engagementId = useEngagementId();

	const dispatch = useDispatch();

	const data = useSelector((store) => getFormBodyDataBySectionId(store, Number(sectionId)));

	const formData = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));

	const bodyContent = useMemo(() => {
		if (Array.isArray(data)) {
			return data.find((body) => body.id === Number(bodyId));
		}

		return null;
	}, [bodyId, data]);

	const component = useMemo(() => getComponent(bodyContent?.bodyTypeId), [bodyContent]);

	const [isLoading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);

		const promiseArray = [];

		const url = `forms/${documentId}/headers/${headerId}/sections/${sectionId}/Bodies?includeAction=true&includeRisks=true&bodyIdList=${bodyId}`;

		promiseArray.push(dispatch(getFormBodiesBySectionId(`${Env.getBaseURL(serviceURL, engagementId)}${url}`)));

		const customExpands = ['headers', 'headers.sections'];

		promiseArray.push(
			dispatch(getFormData(Utility.getUrlForFormData(engagementId, documentId, 'expand=' + customExpands.join(','))))
		);

		Promise.allSettled(promiseArray).finally(() => {
			setLoading(false);
		});
	}, [engagementId, documentId, headerId, sectionId, bodyId, dispatch]);

	return (
		<StyledBodiesContainer>
			{isLoading ? (
				<LoadingIndicator show fullscreen />
			) : (
				component && component.render({documentId, headerId, sectionId, bodyId, engagementId, bodyContent, formData})
			)}
		</StyledBodiesContainer>
	);
}

const StyledBodiesContainer = styled.section`
	display: flex;
	width: 100%;
	height: 100%;
`;
